import React, { useState } from 'react';
import dynamic from 'next/dynamic';
import useTranslation from 'next-translate/useTranslation';

import {
  BusinessTariffCard,
  InformationModal,
  SectionTitle,
  SliderWrapper,
} from '@/ui/index';
import { BrandArrow } from '@/icons/index';

import ContactForm from '@/ui/BusinessContactForm/ContactForm/ContactForm';
import useSlickPositioning from '@/hooks/useSlickPositioning';

const DinamicModal = ({ className, ...props }) => {
  const Component = dynamic(() => import('@/ui/Modal/Modal').catch(() => ''));

  return <Component className={className} {...props} />;
};

const BusinessTariffSlider = ({ data }) => {
  const [modalActive, setModalActive] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const { t } = useTranslation();

  useSlickPositioning();

  const closeModal = () => {
    setModalActive(false);
  };

  const handleConnect = () => {
    setModalActive(true);
  };

  const showSuccessModal = () => {
    closeModal();
    setShowSuccess(true);
  };
  const renderList = (item, key) => (
    <BusinessTariffCard key={key} data={item} handleConnect={handleConnect} />
  );

  return (
    <div itemScope itemType='https://schema.org/WebPage'>
      {!!data?.tariffs?.length && (
        <div className={'section wrapper'}>
          <SectionTitle titleModify={'title--large'}>
            {data?.title}
          </SectionTitle>
          {data?.description && (
            <div className={'common-description half'}>{data?.description}</div>
          )}
          <SliderWrapper
            // className={styles.slider}
            arrows
            nextArrow={<BrandArrow width={17} />}
            prevArrow={<BrandArrow width={17} />}
            options={{ infinite: data?.tariffs.length > 3 }}
          >
            {data?.tariffs.map(renderList)}
          </SliderWrapper>
        </div>
      )}
      <DinamicModal active={modalActive} setActive={closeModal}>
        <ContactForm showSuccess={showSuccessModal} />
      </DinamicModal>
      <InformationModal
        type={'dark'}
        active={showSuccess}
        onClose={() => setShowSuccess(false)}
        description={t('common:successText')}
      />
    </div>
  );
};

export default BusinessTariffSlider;
